module.exports = __webpack_public_path__ + "img/second.45a3d00b.png";